module.exports = __webpack_public_path__ + "img/avatar-default.c632ccb6.png";